var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H2C1.60218 0 1.22065 0.158035 0.939344 0.43934C0.658039 0.720644 0.500004 1.10218 0.500004 1.5V9.5C0.499654 9.58811 0.522591 9.67474 0.566493 9.75113C0.610395 9.82752 0.673702 9.89095 0.750004 9.935C0.826014 9.97888 0.912236 10.002 1 10.002C1.08777 10.002 1.17399 9.97888 1.25 9.935L4 8.345L6.75 9.935C6.8262 9.97819 6.91242 10.0006 7 10C7.08759 10.0006 7.1738 9.97819 7.25 9.935C7.32631 9.89095 7.38961 9.82752 7.43351 9.75113C7.47742 9.67474 7.50035 9.58811 7.5 9.5V1.5C7.5 1.10218 7.34197 0.720644 7.06066 0.43934C6.77936 0.158035 6.39783 0 6 0ZM6.5 8.635L4.25 7.335C4.17399 7.29112 4.08777 7.26801 4 7.26801C3.91224 7.26801 3.82601 7.29112 3.75 7.335L1.5 8.635V1.5C1.5 1.36739 1.55268 1.24021 1.64645 1.14645C1.74022 1.05268 1.8674 1 2 1H6C6.13261 1 6.25979 1.05268 6.35356 1.14645C6.44733 1.24021 6.5 1.36739 6.5 1.5V8.635Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSave);
export default __webpack_public_path__ + "static/media/flagSave.e3bdc3a281a1cf4c0d39477fa8f3c376.svg";
export { ForwardRef as ReactComponent };